
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.077 11a6.918 6.918 0 00-5.357 11.3l-5.52 5.518a.692.692 0 10.979.979L17.7 23.28A6.921 6.921 0 1022.077 11zm0 12.462a5.539 5.539 0 115.538-5.539 5.545 5.545 0 01-5.538 5.539z"}}),_c('path',{attrs:{"d":"M20 39a19 19 0 1119-19 19.021 19.021 0 01-19 19zm0-36a17 17 0 1017 17A17.019 17.019 0 0020 3z"}})])
          )
        }
      }
    